<template>
    <div id="app">
        <router-view></router-view>
        <batch-api ref="batchApi" />
    </div>
</template>

<script>
import BatchApi from "@/components/BatchApi";
import Vue from "vue";
export default {
    name: "App",
    components: { BatchApi },
    mounted() {
        console.log("App.vue mounted");

        // 挂载批量请求组件的函数
        Vue.prototype.batchApi = this.$refs.batchApi.batchApi;
    }
};
</script>

<style lang="scss">
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;

    .row {
        display: flex;
        align-items: center;
    }
}

img {
    max-height: 100%;
    max-width: 100%;
}

* {
    box-sizing: border-box;
    padding: 0;
    margin: 0;
}
</style>
